import { Can, canDoSome, cannotDoSome } from './Can';
import AuthorizedRoute from './AuthorizedRoute';
import { ROLE } from './role';

const access = {}

export { Can, AuthorizedRoute, ROLE, canDoSome, cannotDoSome, access };